module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "home"
  }, [(!_vm.error) ? _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticStyle: {
      "min-height": "35vw"
    },
    attrs: {
      "element-loading-text": "加载中..."
    }
  }, [_c('div', {
    staticClass: "banner"
  }, [_c('div', {
    ref: "bg",
    staticClass: "bg",
    on: {
      "mouseover": function($event) {
        return _vm.bgOver(_vm.$refs.bg)
      },
      "mousemove": function($event) {
        return _vm.bgMove(_vm.$refs.bg, $event)
      },
      "mouseout": function($event) {
        return _vm.bgOut(_vm.$refs.bg)
      }
    }
  }, [_c('transition', {
    attrs: {
      "name": "fade"
    }
  }, _vm._l((_vm.bannerList), function(item, i) {
    return (i === _vm.mark) ? _c('div', {
      key: i,
      staticStyle: {
        "position": "absolute"
      },
      on: {
        "click": function($event) {
          return _vm.onBannerClick(item)
        },
        "mouseover": _vm.stopTimer,
        "mouseout": _vm.startTimer
      }
    }, [_c('img', {
      staticClass: "img1",
      attrs: {
        "src": item.pic
      }
    })]) : _vm._e()
  }), 0)], 1), _vm._v(" "), _c('div', {
    staticClass: "page"
  }, [_c('ul', {
    staticClass: "dots"
  }, _vm._l((_vm.bannerList), function(item, i) {
    return _c('li', {
      key: i,
      staticClass: "dot-active",
      class: {
        'dot': i != _vm.mark
      },
      on: {
        "click": function($event) {
          return _vm.change(i)
        }
      }
    })
  }), 0)])]), _vm._v(" "), (_vm.headHealthList.length > 0) ? _c('div', {
    staticClass: "activity-panel"
  }, [_c('ul', {
    staticClass: "box"
  }, _vm._l((_vm.headHealthList), function(item, i) {
    return _c('li', {
      key: i,
      staticClass: "content",
      on: {
        "click": function($event) {
          return _vm.linkTo(item)
        }
      }
    }, [_c('img', {
      staticClass: "i",
      attrs: {
        "src": item.image
      }
    }), _vm._v(" "), _c('a', {
      staticClass: "cover-link"
    })])
  }), 0)]) : _vm._e(), _vm._v(" "), (_vm.actList.length > 0) ? _c('section', {
    staticClass: "w mt30 clearfix"
  }, [_c('y-shelf', {
    attrs: {
      "title": "活动专区"
    }
  }, [_c('div', {
    attrs: {
      "slot": "right"
    },
    slot: "right"
  }, [_c('div', {
    staticClass: "more",
    on: {
      "click": function($event) {
        return _vm.onMore(5)
      }
    }
  }, [_vm._v("更多")])]), _vm._v(" "), _c('div', {
    staticClass: "floors",
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, _vm._l((_vm.actList), function(item, i) {
    return _c('mall-goods', {
      key: i + 'key',
      attrs: {
        "msg": item
      }
    })
  }), 1)])], 1) : _vm._e(), _vm._v(" "), (_vm.healthList.length > 0) ? _c('section', {
    staticClass: "w mt30 clearfix"
  }, [_c('y-shelf', {
    attrs: {
      "title": "健康专区"
    }
  }, [_c('div', {
    attrs: {
      "slot": "right"
    },
    slot: "right"
  }, [_c('div', {
    staticClass: "more",
    on: {
      "click": function($event) {
        return _vm.onMore(3)
      }
    }
  }, [_vm._v("更多")])]), _vm._v(" "), _c('div', {
    staticClass: "floors",
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, _vm._l((_vm.healthList), function(item, i) {
    return _c('mall-goods', {
      key: i + 'key',
      attrs: {
        "msg": item
      }
    })
  }), 1)])], 1) : _vm._e(), _vm._v(" "), (_vm.likeInfo.length > 0) ? _c('section', {
    staticClass: "w mt30 clearfix"
  }, [_c('y-shelf', {
    attrs: {
      "title": "热门榜单"
    }
  }, [_c('div', {
    attrs: {
      "slot": "right"
    },
    slot: "right"
  }, [_c('div', {
    staticClass: "more",
    on: {
      "click": function($event) {
        return _vm.onMore(2)
      }
    }
  }, [_vm._v("更多")])]), _vm._v(" "), _c('div', {
    staticClass: "floors",
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, _vm._l((_vm.likeInfo), function(item, i) {
    return _c('mall-goods', {
      key: i + 'key',
      attrs: {
        "msg": item
      }
    })
  }), 1)])], 1) : _vm._e(), _vm._v(" "), (_vm.bastList.length > 0) ? _c('section', {
    staticClass: "w mt30 clearfix"
  }, [_c('y-shelf', {
    attrs: {
      "title": "精品推荐"
    }
  }, [_c('div', {
    attrs: {
      "slot": "right"
    },
    slot: "right"
  }, [_c('div', {
    staticClass: "more",
    on: {
      "click": function($event) {
        return _vm.onMore(1)
      }
    }
  }, [_vm._v("更多")])]), _vm._v(" "), _c('div', {
    staticClass: "floors",
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('div', {
    staticClass: "imgbanner",
    on: {
      "click": function($event) {
        return _vm.linkTo(_vm.bastFirst)
      }
    }
  }, [_c('img', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy",
      value: (_vm.bastFirst.image),
      expression: "bastFirst.image"
    }]
  }), _vm._v(" "), _c('a', {
    staticClass: "cover-link"
  })]), _vm._v(" "), _vm._l((_vm.bastList), function(item, i) {
    return _c('mall-goods', {
      key: i + 'key',
      attrs: {
        "msg": item
      }
    })
  })], 2)])], 1) : _vm._e(), _vm._v(" "), (_vm.benefit.length > 0) ? _c('section', {
    staticClass: "w mt30 clearfix"
  }, [_c('y-shelf', {
    attrs: {
      "title": "为您推荐"
    }
  }, [_c('div', {
    attrs: {
      "slot": "right"
    },
    slot: "right"
  }, [_c('div', {
    staticClass: "more",
    on: {
      "click": function($event) {
        return _vm.onMore(4)
      }
    }
  }, [_vm._v("更多")])]), _vm._v(" "), _c('div', {
    staticClass: "floors",
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, _vm._l((_vm.benefit), function(item, i) {
    return _c('mall-goods', {
      key: i + 'key',
      attrs: {
        "msg": item
      }
    })
  }), 1)])], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.error) ? _c('div', {
    staticClass: "no-info"
  }, [_vm._m(0)]) : _vm._e(), _vm._v(" "), _c('el-dialog', {
    staticStyle: {
      "width": "70%",
      "margin": "0 auto"
    },
    attrs: {
      "title": "通知",
      "visible": _vm.dialogVisible,
      "width": "30%"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('span', [_vm._v("首页已升级！XPay个人支付收款系统已上线，赶快去支付体验吧！")]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.dialogVisible = false
      }
    }
  }, [_vm._v("知道了")])], 1)])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "no-data"
  }, [_c('img', {
    attrs: {
      "src": "/static/images/error.png"
    }
  }), _vm._v(" "), _c('br'), _vm._v(" 抱歉！出错了...\n      ")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4fb28d44","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/Home/home.vue
// module id = 481
// module chunks = 7